module.exports = __webpack_public_path__ + "627bb19f76245b41048a9cf3e3e903.png";